"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTournament = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var useTournament = function () {
    var activeTournaments = (0, swr_hooks_1.useActiveTournaments)().data;
    var finishedTournaments = (0, swr_hooks_1.useFinishedTournaments)().data;
    var tournamentToShow = (0, react_1.useMemo)(function () {
        if (activeTournaments && (activeTournaments === null || activeTournaments === void 0 ? void 0 : activeTournaments.length) > 0)
            return activeTournaments === null || activeTournaments === void 0 ? void 0 : activeTournaments[0];
        else if (finishedTournaments && finishedTournaments.length > 0)
            return finishedTournaments === null || finishedTournaments === void 0 ? void 0 : finishedTournaments[0];
        return null;
    }, [activeTournaments, finishedTournaments]);
    return {
        activeTournament: activeTournaments === null || activeTournaments === void 0 ? void 0 : activeTournaments[0],
        tournamentToShow: tournamentToShow,
    };
};
exports.useTournament = useTournament;
